
export const en = {
  site_title: 'Luxury Rental Apartments with Tokyo Tower View',
  
  // Navigation
  nav_home: 'Home',
  nav_rooms: 'Tokyo Tower View Rooms',
  nav_rental_guide: 'Rental Guide',
  nav_life_support: 'Life Support',
  nav_contact: 'Contact',
  
  // Hero section
  hero_title: 'Your Special Space in the Heart of Tokyo',
  hero_subtitle: 'Experience the finest stay in Tokyo with our carefully selected luxury apartments',
  hero_cta: 'View Rooms',
  
  // Features
  features_title: 'Why Choose Us',
  feature_1_title: 'Premium Location',
  feature_1_desc: 'Carefully selected properties in Tokyo\'s prime areas',
  feature_2_title: 'Fully Furnished',
  feature_2_desc: 'Complete amenities to start your life immediately',
  feature_3_title: '24/7 Support',
  feature_3_desc: 'Email support in Japanese, English, and Chinese',
  
  // Rooms
  rooms_title: 'Selected Rooms',
  rooms_subtitle: 'Special spaces tailored to your lifestyle',
  view_details: 'View Details',
  monthly_rent: 'Monthly Rent',
  ask_price: 'ASK',
  reference_price: 'Reference Price',
  
  // Contact page
  contact_title: 'Contact Us',
  contact_subtitle: 'Feel free to contact us via email',
  contact_info_title: 'Contact Information',
  contact_email_label: 'Email Address',
  contact_email_response: 'We will reply via email within 24 hours',
  contact_method_label: 'Contact Method',
  contact_method_email_only: 'Email correspondence only',
  contact_method_note: 'Phone inquiries are not available',
  
  // Contact form
  contact_form_name: 'Name',
  contact_form_name_placeholder: 'John Doe',
  contact_form_email: 'Email Address',
  contact_form_phone: 'Phone Number',
  contact_form_phone_placeholder: '+81-90-1234-5678',
  contact_form_room_interest: 'Room of Interest',
  contact_form_room_select: 'Please select',
  contact_form_room_other: 'Other / Consultation',
  contact_form_move_date: 'Preferred Move-in Date',
  contact_form_message: 'Message',
  contact_form_message_placeholder: 'Please let us know your questions or requests (within 500 characters)',
  contact_form_characters: ' characters',
  contact_form_success: 'Your inquiry has been received. We will reply via email within 24 hours.',
  contact_form_error: 'Failed to send. Please try again later.',
  contact_form_sending: 'Sending...',
  contact_form_submit: 'Send Email Inquiry',
  
  // Room titles
  room_shibuya_title: 'Shibuya Premium Studio',
  room_shinjuku_title: 'Shinjuku Luxury 1LDK',
  room_roppongi_title: 'Roppongi Executive Suite',
  
  // Rental guide
  rental_guide_title: 'Japan Rental Guide',
  rental_guide_subtitle: 'Complete guide for foreigners to rent with peace of mind',
  
  // Footer
  footer_contact_title: 'Contact',
  footer_support_hours: 'Email Support Available',
  footer_copyright: '© 2024 Tokyo Rent. All rights reserved.',
  footer_link: 'Website Builder'
};